module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('div', {
    staticClass: "feedback"
  }, [(false) ? _c('div', {
    staticClass: "button-div",
    on: {
      "click": function($event) {
        _vm.backtop()
      }
    }
  }, [_c('div', {
    staticClass: "top_img"
  })]) : _vm._e(), _vm._v(" "), (_vm.ip_isCn) ? _c('el-popover', {
    attrs: {
      "placement": "left",
      "width": _vm.getLange === 'en' ? 170 : 140,
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "feedback-hover"
  }, [_c('img', {
    attrs: {
      "src": require('../../assets/index/qrCode1.svg')
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fst"
  }, [_vm._v(_vm._s(_vm.$t('_7E461A1085F629F3')))]), _vm._v(" "), _c('p', {
    staticClass: "snd"
  }, [_vm._v(_vm._s(_vm.$t('_1D6BC498A0AD979C')))])]), _vm._v(" "), _c('div', {
    staticClass: "button-div",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('div', {
    staticClass: "feedback-tab-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/qrCode.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback-tab-txt"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('_7005434934422454')) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-div",
    on: {
      "click": _vm.goCollection
    }
  }, [_c('div', {
    staticClass: "feedback-tab-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/if_like.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback-tab-txt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('D474')) + "\n        ")])]), _vm._v(" "), _c('a', {
    staticClass: "button-div",
    attrs: {
      "href": "tencent://message/?uin=2230259928&Site=&Menu=yes"
    }
  }, [_c('div', {
    staticClass: "feedback-tab-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/index/if_online.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback-tab-txt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('D475')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "button-div",
    on: {
      "click": function($event) {
        _vm.DialogVisible()
      }
    }
  }, [_c('div', {
    staticClass: "feedback-tab-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/member/feedback_l.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback-tab-txt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('_D483F385C3B31538')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "gotop button-div",
    on: {
      "click": _vm.backtop
    }
  }, [_c('div', {
    staticClass: "feedback-tab-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/member/back_top.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback-tab-txt"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('D349')) + "\n        ")])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('D350'),
      "visible": _vm.centerDialogVisible,
      "width": "610px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('D351')) + "（" + _vm._s(_vm.$t('_5FF8D4C1679F272E')) + "）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 8,
        maxRows: 12
      },
      "placeholder": _vm.$t('D352')
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('D191')))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('SEARCH_05')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e77bc53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/feedback.vue
// module id = 619
// module chunks = 39